(function () {
  if (window.__saleTipsCopyBound) return;
  window.__saleTipsCopyBound = true;

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }

    var input = document.createElement('textarea');
    input.value = text;
    input.setAttribute('readonly', '');
    input.style.position = 'absolute';
    input.style.left = '-9999px';
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
    return Promise.resolve();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-sale-tips-copy]');
    if (!button) return;

    var code = button.getAttribute('data-code');
    if (!code) return;

    var copyLabel = button.getAttribute('data-label-copy') || 'Copy Code';
    var copiedLabel = button.getAttribute('data-label-copied') || 'Copied';

    copyText(code)
      .then(function () {
        button.textContent = copiedLabel;
        button.setAttribute('aria-live', 'polite');
        window.setTimeout(function () {
          button.textContent = copyLabel;
          button.removeAttribute('aria-live');
        }, 2000);
      })
      .catch(function () {});
  });
})();
